import React from "react";
import RegisterComponent from "../../component/register";
export function Register() {
  return (
    <div style={{height:'92vh',overflow:'hidden', color:'var(--text-clr)'}}>
      <RegisterComponent />
    </div>
  );
}
